class VwKullaniciEkranraporDTO {
     //
        // Summary:
        //     Gets the Content-Type header for the response.
    pkRaporsorgu?: number;
    kullaniciId?: number;
    adi?: string;
    fkModul?: number;
    sira?: number;
    ekrankodu?: string;
    printerType?: number;
}
export default VwKullaniciEkranraporDTO;